enum ToolboxElementType{
  Layout = 1,
  UiElement = 2,
  Control = 4
}

export default ToolboxElementType;
